export const SET_CONTAINER_POSITION = 'Scroll/SET_CONTAINER_POSITION';
export const RESET_CONTAINER_POSITION = 'Scroll/RESET_CONTAINER_POSITION';
export const RESET_ALL_CONTAINER_POSITIONS = 'Scroll/RESET_ALL_CONTAINER_POSITIONS';
